import { useStore } from 'effector-react'

import { $hotBuyOrders, $totalCountOfHotBuyOrders, getHotBuyOrderList, hotBuyOrdersListMounted, } from './model'
import { HotBuyOrderRequest } from './types'

export const useHotBuyOrdersList = () => {
  const onChangeHotBuyOrdersList = ({
    limit,
    page,
    orderBy,
    orderDirection,
    searchText,
    filters,
  }: HotBuyOrderRequest) => {
    hotBuyOrdersListMounted({
      limit,
      page,
      orderBy,
      orderDirection,
      searchText,
      filters,
    })
  }

  const hotBuyOrders = useStore($hotBuyOrders)
  const totalCountOfHotBuyOrders = useStore($totalCountOfHotBuyOrders)
  const loading = useStore(getHotBuyOrderList.pending)
  return {
     hotBuyOrders,
     totalCountOfHotBuyOrders,
    loading,
     onChangeHotBuyOrdersList,
  }
}
